<template>
  <div class="row">
    <div class="col-md-6 col-xl-6 col-xm-12">
      <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
        <Form ref="redeForm" @submit="payer" :validation-schema="contratSchema">
          <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30">
            <h5 class="card-title fw-bold mb-15 mb-lg-20 mb-xl-25"></h5>
            <div class="border p-2 p-lg-4 border-dark border-opacity-10">
              <div class="mb-15 mb-md-20">
                <label for="contrat" class="form-label fw-medium text-black">
                  Contrat / Usager
                  <span class="text-danger">*</span>
                </label>
                <Field name="contrat" v-model="contrat" class="form-control shadow-none fs-md-15 text-black"
                  v-slot="{ field }">
                  <Multiselect v-model="field.value" v-bind="field" :filter-results="false" :min-chars="2"
                    :resolve-on-load="false" :delay="0" :searchable="true" :options-limit="300" :options="async (query) => {
                      if (query.length >= 3) {
                        const results = await reupererContrat(query);
                        if (results && results.length > 0) {
                          return results;
                        } else {
                          return [
                            { value: '', label: 'Aucun enregistrement trouvé' },
                          ];
                        }
                      } else {
                        return [];
                      }
                    }
                      " noOptionsText="Tapez au moins deux caractères" placeholder="Rechercher un contrat" />
                </Field>
                <ErrorMessage name="contrat" class="text-danger" />
              </div>
              <div class="mb-15 mb-md-20">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="form-label fw-medium text-black">
                    Impayés
                    <span class="text-danger">*</span>
                  </label>
                  <Field name="impaye" v-slot="{ field }" v-model="impp">
                    <Multiselect :options="impayeOptions" :searchable="true" v-model="field.value" v-bind="field"
                      placeholder="Sélectionner un impayé" />
                  </Field>
                  <ErrorMessage name="impaye" class="text-danger" />
                </div>
              </div>
              <div class="mb-15 mb-md-20">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="form-label fw-medium text-black">
                    Mode de paiement
                    <span class="text-danger">*</span>
                  </label>
                  <Field name="mode" v-slot="{ field }" v-model="mode">
                    <Multiselect :options="modes" :searchable="true" v-model="field.value" v-bind="field"
                      placeholder="Sélectionner un mode" />
                  </Field>
                  <ErrorMessage name="mode" class="text-danger" />
                </div>
              </div>
              <div class="mb-15 mb-md-20" v-if="showTransactionIdField">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="form-label fw-medium text-black">
                    Référence externe
                    <span class="text-danger">*</span>
                  </label>
                  <Field type="text" name="transactionId" v-model="transactionId"
                    class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer l'ID de transaction" />
                  <ErrorMessage name="transactionId" class="text-danger" />
                </div>
              </div>
              <div class="mb-15 mb-md-20">
                <div class="row">
                  <div class="col-md-6">
                    <label for="mois" class="form-label fw-medium text-black">
                      Nombre de mois
                      <span class="text-danger">*</span>
                    </label>
                    <Field type="number" name="mois" v-model="mois" class="form-control shadow-none fs-md-15 text-black"
                      @keydown="($event.key === 'e' || $event.key === 'E' || $event.key === '+' || $event.key === '-') && $event.preventDefault()"
                      min="1" />
                    <ErrorMessage name="mois" class="text-danger" />
                  </div>
                  <div class="col-md-6">
                    <label for="montant" class="form-label fw-medium text-black">
                      Montant
                      <span class="text-danger">*</span>
                    </label>
                    <Field name="montant" v-model="montant" :disabled="true"
                      class="form-control shadow-none fs-md-15 text-black" />
                    <ErrorMessage name="montant" class="text-danger" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer p-15 p-sm-20 p-md-25 p-lg-30 bg-white">
            <button v-show="valideEtape1"
              class="default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
              type="submit">
              Payer
            </button>
            <button
              class="default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
              type="button" v-show="!valideEtape1" disabled>
              <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
              <span class="visually-hidden">Chargement...</span>
            </button>
            <router-link to="/liste-paiement" class="btn btn-danger transition border-0 lh-1 fw-medium"><i
                class="flaticon-delete lh-1 me-1 position-relative top-2"></i>
              <span class="position-relative"></span>Annuler
            </router-link>
          </div>
        </Form>
      </div>
    </div>
    <div class="col-md-6 col-xl-6 col-xm-12">
      <div class="card mb-25 border-0 rounded-0 bg-white">
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
          <div class="mb-15 mb-md-30 d-sm-flex align-items-center justify-content-between">
            <h6 class="card-title fw-bold mb-0">Les impayés</h6>
            <div class="card-select mt-10 mt-sm-0 mb-10 mb-sm-0 d-flex align-items-center ps-10 pe-10 pt-5 pb-5">
              <span class="fw-medium text-muted me-8">TOTAL IMPAYE : {{ somRedevance }}</span>
            </div>
          </div>
          <div class="table-responsive">
            <table class="table text-nowrap align-middle mb-0">
              <thead>
                <tr>
                  <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                    #
                  </th>
                  <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                    Année
                  </th>
                  <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                    Loyer
                  </th>
                  <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                    Nmbre Mois
                  </th>
                  <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                    Etat
                  </th>
                </tr>
              </thead>
              <tbody v-if="impayes">
                <tr v-for="(imp, index) in impayes" :key="index" class="clickable-row">
                  <th class="shadow-none lh-1 fw-bold ps-0">
                    {{ index + 1 }}
                  </th>
                  <td class="shadow-none lh-1 fw-semibold text-dark">
                    {{ imp.annee }}
                  </td>
                  <td class="shadow-none lh-1 fw-semibold text-dark">
                    {{ imp.taux }}
                  </td>
                  <td class="shadow-none lh-1 fw-medium text-body-tertiary">
                    {{ imp.mois }}
                  </td>
                  <td class="shadow-none lh-1 fw-medium text-body-tertiary">
                    <span class="badge text-outline-danger">En attente</span>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <th class="shadow-none lh-1 fw-bold ps-0" colspan="4">
                    AUCUNE IMPAYE TROUVE
                  </th>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!--
        <div>
          <button @click="telechargerFichier2">Télécharger fichier</button>
        </div>
      -->
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch, reactive, toRef, onMounted, computed } from "vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import {
  error,
  success,
  format_date,
  telechargerFichier2,
  getUrlApiForFiles,
} from "@/utils/utils";
import { useRouter } from "vue-router";
import ApiService from "@/services/ApiService";
import JwtService from "@/services/JwtService";
import * as Yup from "yup";
import Multiselect from "@vueform/multiselect";
import axios from "axios";
import {
  openKkiapayWidget,
  addKkiapayListener,
  removeKkiapayListener,
} from "kkiapay";
import Swal from "sweetalert2";
import CryptoJS from "crypto-js";
import { KKIAPAY } from "@/models/KKIAPAY";
import router from "@/router";

export default defineComponent({
  name: "AddPaiement",
  components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect,
  },
  setup: () => {
    const selectedImp = ref(null);
    // Fonction pour mettre à jour l'ID sélectionné
    const selectImp = (valeur: any) => {
      selectedImp.value = valeur;
    };
    const nombre1 = ref(1);
    const nombre2 = ref(12);

    const contratSchema = Yup.object().shape({
      contrat: Yup.string().required("Le contrat est obligatoire"),
      impaye: Yup.number().required("Selectionner un impayé"),
      mois: Yup.number()
        .default(0)
        .typeError("Veuillez entrer un nombre")
        .min(1, `Le nombre minimale est 1`)
        .max(nombre2.value, "Le nombre maximal est " + nombre2.value)
        .required("Le nombre de mois est bligatoire"),
      mode: Yup.number().required("Le mode est obligatoire"),
      montant: Yup.number().required("Le montant est obligatoire"),
      transactionId: Yup.string()
        .nullable()
        .test("transactionId-required", "La référence externe du paiement est obligatoire", function (value) {
          const mode = this.parent.mode;
          if (mode !== 1 && mode !== 2 && mode !== 0) {
            return value !== null && value !== undefined && value.trim() !== "";
          }
          return true;
        }),
    });
    const impayes = ref<any[]>([]);

    const contrat = ref(0);
    const impp = ref(null);
    const valideEtape1 = ref(true);
    const montant = ref(0);
    const somRedevance = ref(0);
    var check = reactive({
      typeError: "RAS",
      idTransaction: 0,
    });

    async function successHandler(response, values, { resetForm }) {
      // Mise à jour de l'objet check avec les informations de la réponse de succès
      check.typeError = "SUCCESS";
      check.idTransaction = response.transactionId;
      values["mode"] = 2;
      values["idTransaction"] = check.idTransaction;
      values["check"] = check;
      // Bloc de code à exécuter lorsque le paiement est un succès
      if (check.typeError === "SUCCESS") {
        // Appel de la fonction addAbonnement et attente de son exécution
        await addAPaiement(values, { resetForm });
        valideEtape1.value = true;
      } else {
        check.typeError = "ECHOUE";
        check.idTransaction = 0;
      }

      // Retourne les données après l'exécution
      return { check, response };
    }

    async function failHandler(response, values, { resetForm }) {
      // Mise à jour de l'objet check avec les informations de l'échec
      check.typeError = "ECHOUE";
      check.idTransaction = response.transactionId;

      values["check"] = check;
      if (check.typeError === "ECHOUE") {
        // Appel de la fonction addAbonnement et attente de son exécution
        await addAPaiement(values, { resetForm });
        valideEtape1.value = true;
      }

      // Retourne les données après l'exécution
      return { check, response };
    }

    const contrats = ref([]);
    const mode = ref(0);
    const modes = ref([]);
    const lesContrats = ref<any[]>([]);
    const transactionId = ref("");
    
    // Computed pour déterminer si on doit afficher le champ transactionId
    const showTransactionIdField = computed(() => {
      return mode.value !== 1 && mode.value !== 2 && mode.value !== 0;
    });
    const reupererMode = async () => {
      try {
        const response = await ApiService.get("listeMode");
        if (response.data) {
          return (modes.value = response.data.data.map((el) => {
            return {
              value: el.id,
              label: el.libelle,
            };
          }));
        }
      } catch (err) {
        if (axios.isAxiosError(err) && err.response) {
          error(err.response.data.message || err.message);
        } else {
          if (err instanceof Error) {
            error(err.message);
          } else {
            error(String(err));
          }
        }
      }
    };
    const reupererContrat = async (recherche) => {
      try {
        impp.value = null;
        impayes.value = [];
        const response = await ApiService.post("listeContrat", { recherche });
        lesContrats.value = response.data.data;
        if (response.data) {
          return (contrats.value = response.data.data.map((el) => {
            return {
              value: el.id,
              label:
                el.ref + " - Lo : " + el.locataire + " - Ex : " + el.exploitant,
            };
          }));
        }
      } catch (err) {
        if (axios.isAxiosError(err) && err.response) {
          error(err.response.data.message || err.message);
        } else {
          if (err instanceof Error) {
            error(err.message);
          } else {
            error(String(err));
          }
        }
      }
    };

    const payer = async (values, { resetForm }) => {
      valideEtape1.value = false;
      const imp = impayes.value.find(
        (el) => el.id == (values["impaye"] === 0 ? null : values["impaye"])
      );
      if (values.montant == 0) {
        error("Le montant semble être égale à 0");
        return 0;
      }
      values["arrieres"] = imp;
      if (parseInt(values.mois) > nombre2.value) {
        Swal.fire({
          title: "Erreur",
          toast: true,
          text:
            "Le nombre de mois ne peut pas être supérieur à " + nombre2.value,
          icon: "error",
          timer: 5000,
          position: "top-right",
          showConfirmButton: false,
        });
        return;
      }
      if (values.mode == 1) {
        try {
          const result = await Swal.fire({
            text:
              "Vous êtes sur le point de faire un paiement d'une somme de " +
              values.montant +
              " F CFA",
            icon: "warning",
            buttonsStyling: true,
            showCancelButton: true,
            confirmButtonText: "Payer",
            cancelButtonText: `Annuler`,
            allowOutsideClick: false,
            allowEscapeKey: false,
            heightAuto: false,
            customClass: {
              confirmButton: "btn btn-danger",
            },
          });

          if (result.isConfirmed) {
            values["check"] = KKIAPAY.check;
            await addAPaiement(values, { resetForm });
          } else {
            valideEtape1.value = true;
          }
        } catch (err) {
          if (axios.isAxiosError(err) && err.response) {
            error(err.response.data.message || err.message);
          } else {
            if (err instanceof Error) {
              error(err.message);
            } else {
              error(String(err));
            }
          }
          valideEtape1.value = true;
        }
        resetForm();
        return;
      }
      

      if (values.mode == 2) {
        values.mode = 2;
        try {
          const result = await Swal.fire({
            text:
              "Vous êtes sur le point de faire un paiement d'une somme de " +
              values.montant +
              " F CFA",
            icon: "warning",
            buttonsStyling: true,
            showCancelButton: true,
            confirmButtonText: "Payer",
            cancelButtonText: `Annuler`,
            allowOutsideClick: false,
            allowEscapeKey: false,
            heightAuto: false,
            customClass: {
              confirmButton: "btn btn-danger",
            },
          });

          if (result.isConfirmed) {
            KKIAPAY.kkia(values.montant);
            await new Promise<void>((resolve) => {
              addKkiapayListener("failed", (event) => {
                failHandler(event, values, { resetForm });
                resolve();
              });

              addKkiapayListener("success", (event) => {
                successHandler(event, values, { resetForm });
                resolve();
              });

              const checkRef = toRef(check);

              let resolved = false;

              const intervalId = setInterval(() => {
                if (!resolved && checkRef.value.typeError !== "ECHOUE") {
                  clearInterval(intervalId);
                  resolved = true;
                  resolve();
                }
              }, 500);
            });
          } else {
            valideEtape1.value = true;
          }
        } catch (error) {
          valideEtape1.value = true;
        }
        return;
      }

      // Gestion des modes différents de 1 et 2
      if (values.mode !== 1 && values.mode !== 2 && values.mode > 2) {
        try {
          // Vérifier que transactionId est présent
          if (!values.transactionId || values.transactionId.trim() === "") {
            error("L'ID de transaction est obligatoire");
            valideEtape1.value = true;
            return;
          }

          // Avant soumission, configurer check
          check.typeError = "SUCCESS";
          check.idTransaction = values.transactionId;
          values["idTransaction"] = check.idTransaction;
          values["check"] = check;

          const result = await Swal.fire({
            text:
              "Vous êtes sur le point de faire un paiement d'une somme de " +
              values.montant +
              " F CFA",
            icon: "warning",
            buttonsStyling: true,
            showCancelButton: true,
            confirmButtonText: "Payer",
            cancelButtonText: `Annuler`,
            allowOutsideClick: false,
            allowEscapeKey: false,
            heightAuto: false,
            customClass: {
              confirmButton: "btn btn-danger",
            },
          });

          if (result.isConfirmed) {
            await addAPaiement(values, { resetForm });
          } else {
            valideEtape1.value = true;
          }
          check.typeError = "RAS";
          check.idTransaction = 0;
        } catch (err) {
          if (axios.isAxiosError(err) && err.response) {
            error(err.response.data.message || err.message);
          } else {
            if (err instanceof Error) {
              error(err.message);
            } else {
              error(String(err));
            }
          }
          valideEtape1.value = true;
        }
        return;
      }
      
      // Si aucun mode ne correspond, réinitialiser le bouton
      valideEtape1.value = true;
    };

    const openAndPrint = (url: string) => {
      const newWindow = window.open(url, "_blank");

      if (newWindow) {
        newWindow.onload = () => {
          newWindow.print();
        };
      } else {
        console.error("Impossible d'ouvrir la fenêtre");
      }
    };
    function openNewWindow(data: any) {
      openAndPrint(getUrlApiForFiles("Recu", data.refPaiement + ".pdf"));
    }

    const addAPaiement = async (values, { resetForm }) => {
      await ApiService.post("/paiement", values)
        .then(async ({ data }) => {
          if (data.code == 200) {
            error(data.message);
            const maFonction = async () => {
              const result = await Swal.fire({
                html: `<div>Cliquer sur le bouton Aperçu ci-dessous pour avoir un aperçu de votre document</div>`,
                icon: "success",
                buttonsStyling: true,
                confirmButtonText: "Aperçu",
                showCancelButton: false,
                cancelButtonText: `Fermer`,
                allowOutsideClick: false,
                allowEscapeKey: false,
                heightAuto: false,
                customClass: {
                  confirmButton: "btn btn-success",
                  cancelButton: "btn btn-warning",
                },
              });

              if (result.isConfirmed) {
                openNewWindow(data.data);
              }
            };
            setTimeout(maFonction, 3000);
          }
          if (data.code == 201) {
            success(data.message);
            resetForm();
            router.push({ name: "ListePaiementPage" });
            const maFonction = async () => {
              const result = await Swal.fire({
                html: `<div>Cliquer sur le bouton Aperçu ci-dessous pour avoir un aperçu de votre document</div>`,
                icon: "success",
                buttonsStyling: true,
                confirmButtonText: "Aperçu",
                showCancelButton: false,
                cancelButtonText: `Fermer`,
                allowOutsideClick: false,
                allowEscapeKey: false,
                heightAuto: false,
                customClass: {
                  confirmButton: "btn btn-success",
                  cancelButton: "btn btn-warning",
                },
              });

              if (result.isConfirmed) {
                openNewWindow(data.data);
              }
            };
            // Utiliser setTimeout pour exécuter la fonction après la durée spécifiée
            setTimeout(maFonction, 3000);
          }
        })
        .catch(({ response }) => {
          error(response.data.message);
        });
    };

    const loyer = ref(0);
    const mois = ref(0);
    const calculeMontant = () => {
      if (contrat.value) {
        if (loyer.value != 0) {
          if (mois.value < 1 || mois.value > 12) {
            Swal.fire({
              title: "Erreur",
              text: "Veuillez saisir un mois valide.",
              icon: "error",
              toast: true,
              timer: 5000,
              position: "top-right",
              showConfirmButton: false,
            });
            return;
          }

          montant.value = loyer.value * mois.value;
        } else {
          Swal.fire({
            title: "Erreur",
            text: "Veuillez saisir un loyer valide.",
            icon: "error",
            toast: true,
            timer: 5000,
            position: "top-right",
            showConfirmButton: false,
          });
          return;
        }
      }
    };
    watch(mois, (newValue, oldValue) => {
      calculeMontant();
    });

    watch(impp, (newValue, oldValue) => {
      const ar = impayes.value.find(
        (el) => (el.id == null ? 0 : el.id) === newValue
      );
      if (ar) {
        nombre2.value = ar.mois;
      }
    });
    const impayeOptions = ref();

    watch(contrat, (newValue, oldValue) => {
      if (oldValue !== newValue && lesContrats.value.length > 0) {
        const cont = lesContrats.value.find((el) => el.id === newValue);
        if (cont) {
          impayes.value = cont.arrieres;

          if (impayes.value.length > 0) {
            somRedevance.value = impayes.value.reduce(
              (acc, curr) =>
                acc + parseFloat(curr.taux) * parseFloat(curr.mois),
              0
            );
          }
          impayeOptions.value = impayes.value.map((el) => {
            return {
              value: el.id == null ? 0 : el.id,
              label: "A - " + el.annee + " M-" + el.mois,
            };
          });
          loyer.value = parseFloat(cont.loyer);
        } else {
          impayes.value = [];
          somRedevance.value = 0;
          loyer.value = 0;
        }
      }
    });

    onMounted(async () => {
      await reupererMode();
    });

    return {
      payer,
      valideEtape1,
      selectImp,
      openNewWindow,
      selectedImp,
      impayeOptions,
      impp,
      failHandler,
      reupererContrat,
      mois,
      contratSchema,
      montant,
      mode,
      nombre1,
      nombre2,
      impayes,
      somRedevance,
      contrat,
      modes,
      addAPaiement,
      format_date,
      transactionId,
      showTransactionIdField,
    };
  },
});
</script>
<style>
.clickable-row {
  cursor: pointer;
}

.clickable-row:hover {
  background-color: #bf6b6b;
}

.selected-row {
  border: 2px solid green;
  color: #fff;
  background-color: #0f4030;
  /* Couleur de fond vert clair */
}
</style>
